import { render, staticRenderFns } from "./MaintenanceTable.vue?vue&type=template&id=3a0fc0c6&scoped=true&"
import script from "./MaintenanceTable.vue?vue&type=script&lang=js&"
export * from "./MaintenanceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0fc0c6",
  null
  
)

export default component.exports